import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Service from "./components/Service";
import Member from "./components/Member";
import Cases from "./components/Cases";
import FAQ from "./components/FAQ";
import Company from "./components/Company";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

import PrivacyPolicyPage from "./components/PrivacyPolicyPage";

const HomePageLayout = () => {
  return (
    <>
      <Hero />
      <About />
      <Service />
      <Member />
      <Cases />
      <FAQ />
      <Company />
      <Contact />{" "}
    </>
  );
};

function App() {
  return (
    <Router>
      <Header />
      <main style={{ flexGrow: 1 }}>
        {" "}
        <Routes>
          <Route path="/" element={<HomePageLayout />} />
          <Route path="/faq" element={<FAQ fullPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
